export const specialSubscriptionPlans: string[] = [
    'tester-subscription',
    'personalized-subscription-individual',
    'personalized-subscription'
  ];

export const unlimitedCreditsSubscriptionPlans: string[] = [
    'classic-subscription',  // We talk Share
    'premium-subscription'   // We talk Coach
  ];